export const PARTNER = {
  ONO: "ONO",
  MITRATA: "MITRATA",
} as const;

export type Partner = (typeof PARTNER)[keyof typeof PARTNER];

// role type
export const ROLE_TYPE = {
  ADMIN: "ADMIN",
  FINANCE_MANAGER: "FINANCE_MANAGER",
  RISK_MANAGER: "RISK_MANAGER",
  READ_ONLY: "READ_ONLY",
} as const;

export type Role_type = (typeof ROLE_TYPE)[keyof typeof ROLE_TYPE];
